module.exports = __webpack_public_path__ + "img/renew-contract.c26993b5.svg";